import { render } from "./CategorySelector.vue?vue&type=template&id=e2f4c100&scoped=true"
import script from "./CategorySelector.vue?vue&type=script&lang=js"
export * from "./CategorySelector.vue?vue&type=script&lang=js"

import "./CategorySelector.vue?vue&type=style&index=0&id=e2f4c100&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f4c100"]])

export default __exports__